import { takeEvery, put, call, all } from 'redux-saga/effects';

import { putAndWait } from 'modules/app/sagas';
import * as core from 'modules/campaigns/actions/core';
import * as actions from 'modules/campaigns/actions/send';
import * as types from 'modules/campaigns/actionTypes';
import * as listCore from 'modules/contactLists/actions/core';
import { createNotification } from 'modules/toast-notifications/actions';

function* initializeError() {
  yield all([
    put(
      createNotification({
        type: 'error',
        message: {
          id: 'http.error.message',
          defaultMessage: 'Oops! Something went wrong.',
        },
      })
    ),
    put(actions.closeSendModal()),
    put(actions.sendModalReady(false)),
  ]);
}

function* initialize({ payload: campaignId }) {
  const fetchCampaignResponse = yield putAndWait(core.fetchCampaign(campaignId, { source: 'send-campaign' }));
  let { error } = fetchCampaignResponse;
  if (!error) {
    const contactListId = fetchCampaignResponse.payload.contactList.id;
    const contactListResponse = yield putAndWait(listCore.fetchContactList(contactListId));
    error = contactListResponse.error;
  }

  if (error) {
    yield call(initializeError);
  }
  yield put(actions.sendModalReady(!error));
}

export default function* sendCampaignSaga() {
  yield takeEvery(types.OPEN_SEND_MODAL, initialize);
}
